const translations = {
    flights: 'Flights',
    groups: 'Groups',
    maps: 'Maps'
};

export default translations;
